// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

/////////////////////////////////////////
// APPLICATION GENERATION LIMIT SCHEMA
/////////////////////////////////////////

export const ApplicationGenerationLimitSchema = z.object({
  id: z.string(),
  tenantId: z.string(),
  applicationId: z.string(),
  codeGraphLimit: z.number().int().nullable(),
  signalGenerationLimit: z.number().int().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type ApplicationGenerationLimit = z.infer<typeof ApplicationGenerationLimitSchema>

export default ApplicationGenerationLimitSchema;
